import React from 'react'
import classNames from 'classnames'

type Props = {
  color: string
  header: string
  bodyClassname?: string
}

const Card: React.FC<Props> = ({
  color,
  header,
  bodyClassname,
  children
}) => (
  <div className={classNames('card widgets', color)}>
    <div className="card-header">
      {header}
    </div>
    <div className={classNames('card-body', bodyClassname)}>
      {children}
    </div>
  </div>
)

export default Card
